import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IFrameCommunicationService {
  private readonly messages$ = new Subject<Message>();
  messageTriggered = false;

  constructor() {
    window.addEventListener('message', this.messageListener);
  }

  destroy() {
    window.removeEventListener('message', this.messageListener);
  }

  on(messageType: MessageType): Observable<Message> {
    this.messageTriggered = true;
    return this.messages$.pipe(filter(message => message.type === messageType));
  }

  private readonly messageListener = (event: MessageEvent): void => {
    if (event.data && event.data.type) {
      this.messages$.next(event.data);
    }
  };
}

export enum MessageType {
  OverlayClose = 'OVERLAY_CLOSE',
  OverlayOpen = 'OVERLAY_OPEN',
  BeforeUnload = 'BEFORE_UNLOAD',
  DOMContentLoaded = 'DOM_CONTENT_LOADED',
  CanDeactivate = 'CAN_DEACTIVATE',
  PreventDeactivation = 'PREVENT_DEACTIVATION',
  AllowDeactivation = 'ALLOW_DEACTIVATION',
  MMCPage = 'MMC_TAB_ENABLE'
}

export interface Message {
  type: MessageType;
  payload?: any;
}
